<template>
  <el-container class="wrapper" direction="vertical">
      <el-header class="header">
        <div class="hearder-wrap">
            <span v-show="route.path !== '/project' && route.path !== '/map' && route.path !== '/news' && route.path !== '/about'" class='hearder-back' @click.stop="goBack">
              <img class="hearder-back-img" src="../../../static/images/back.png" alt="">
              返回
            </span>
            <el-dropdown class="hearder-wrap-dropdown">
              <span class="el-dropdown-link">
                你好，{{username}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item @click.native="exitLogin">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

           <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
            <el-menu-item index="/project" >首页</el-menu-item>
            <el-menu-item index="/map">区域展示</el-menu-item>
            <el-menu-item index="/news">消息</el-menu-item>
            <el-menu-item index="/about">关于我们</el-menu-item>
          </el-menu>
        </div>
      </el-header>
    <el-container>
      <el-container direction="vertical" style="position:relative;width:0%">
        <el-main style="padding-bottom:65px; height:100%;">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
   <el-footer class="footer">Copyright © 网站名称 | 备案号</el-footer>
  </el-container>
</template>

<script>
import vBread from './bread.vue';
export default {
  data(){
    return {
      activeIndex:'',
      username:this.$sess.get('userInfo').username
    }
  },
  components:{vBread},
  watch:{
    route:{
      handler(oldVal,newVal){
        let path = this.$route.path
        this.activeIndex = path;
        if(path === '/machineDetai' || path === '/machine' || path === '/home'){
          this.activeIndex = '/project'
        }
        if(oldVal.path === newVal.path){
           this.$router.go(0)
        }
      },  
      deep:true,
    }
  },
  computed:{
    route(){
      return this.$route 
    }
  },
  mounted(){
    this.activeIndex = this.route.path
  },
  methods: {
    handleSelect(e){
      this.$router.push(e)
    },
    goBack(){
      this.$router.back();
    },
    exitLogin(){
      this.$sess.remove('userInfo');
      this.$sess.remove('bgImg');
      this.$sess.remove('delId');
      this.$router.push('/login')
    }
  },
}
</script>

<style>

</style>
